export default function FormInput(props){

    const showError = props.showError && !props.validation
    const classBorderError = showError ? 'border border-red-500' : ''
    const inputBkgClass = !props.isProduct ? 'bg-gray-200' : ''

    const errorMessage = props.name === 'correo' ? "Escriba un correo válido" : "Este campo no puede ser vacío"

    return(
        <div className="container-form-input">
            <label className="block tracking-wide text-white text-xl font-semibold mb-2">
                {props.inputname}
            </label>
            {props.type === 'textarea' ? 
                <textarea className={`appearance-none block w-full 
                ${inputBkgClass} text-gray-700 text-xl border rounded py-3 px-4 mb-3 
                leading-tight focus:outline-none focus:bg-white ${classBorderError}`}
                placeholder={props.placeholder}
                value={props.value} name={props.name} onChange={props.setValue}
                rows={5}/>
            : 
                <input className={`appearance-none block w-full 
                ${inputBkgClass} text-gray-700 text-xl border rounded py-3 px-4 mb-3 
                leading-tight focus:outline-none focus:bg-white ${classBorderError}`} 
                type={props.type} placeholder={props.placeholder}
                value={props.value} name={props.name} onChange={props.setValue}/>
            }
            {showError ?
                <p className="text-red-500 text-md italic" style={{fontWeight: 650}}>{errorMessage}</p>
            :<></>
            }        
        </div>
    )
}